import I18n from 'I18n';
export const getGdprSubmissionText = () => {
  const privacyPolicyLabel = 'legal.gdpr-text';
  return I18n.text(privacyPolicyLabel, {
    termsOfServiceLink: 'http://www.hubspot.com/terms-of-service',
    privacyPolicyLink: 'https://legal.hubspot.com/privacy-policy'
  });
};